"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
function SvgComponent(props) {
    return React.createElement("svg", Object.assign({ viewBox: "0 0 512 512" }, props),
        React.createElement("rect", { x: 336, y: 336, width: 80, height: 80, rx: 8, ry: 8 }),
        React.createElement("rect", { x: 272, y: 272, width: 64, height: 64, rx: 8, ry: 8 }),
        React.createElement("rect", { x: 416, y: 416, width: 64, height: 64, rx: 8, ry: 8 }),
        React.createElement("rect", { x: 432, y: 272, width: 48, height: 48, rx: 8, ry: 8 }),
        React.createElement("rect", { x: 272, y: 432, width: 48, height: 48, rx: 8, ry: 8 }),
        React.createElement("path", { d: "M448,32H304a32,32,0,0,0-32,32V208a32,32,0,0,0,32,32H448a32,32,0,0,0,32-32V64A32,32,0,0,0,448,32ZM416,168a8,8,0,0,1-8,8H344a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8Z" }),
        React.createElement("path", { d: "M208,32H64A32,32,0,0,0,32,64V208a32,32,0,0,0,32,32H208a32,32,0,0,0,32-32V64A32,32,0,0,0,208,32ZM176,168a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8Z" }),
        React.createElement("path", { d: "M208,272H64a32,32,0,0,0-32,32V448a32,32,0,0,0,32,32H208a32,32,0,0,0,32-32V304A32,32,0,0,0,208,272ZM176,408a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V344a8,8,0,0,1,8-8h64a8,8,0,0,1,8,8Z" }));
}
exports.default = SvgComponent;
